import React from 'react';
import { EssaySendSidebar } from './essay-send-sidebar';
import { EssaySendContent } from './essay-send-content';
import { EssaySendPlayful } from './Playful';
import useAuthorityLevel from '@/hooks/useAuthorityLevel';
import usePlayfulStudent from '@/hooks/usePlayfulStudent';
import { Error404 } from '@/components/custom/error';
import { Dashboard } from '@/layouts/dashboard';

export function EssaySend({ essayId, studentId, uri }) {
  const authorityLevel = useAuthorityLevel();
  const isPlayfulStudentTheme = usePlayfulStudent();

  const isAdmin = authorityLevel !== 'student';

  if (!isAdmin && studentId) return <Error404 />;
  if (isAdmin && !studentId) return <Error404 />;

  if (isPlayfulStudentTheme) {
    return (
      <EssaySendPlayful
        essayId={essayId}
        uri={uri}
      />
    );
  }

  return (
    <Dashboard>
      <EssaySendSidebar essayId={essayId} />
      <EssaySendContent
        essayId={essayId}
        studentId={studentId}
      />
    </Dashboard>
  );
}
